import React, {Component} from 'react';
import {  Switch, Link, Route } from 'react-router-dom';
import MachinesContent from '../components/MachinesContent'; 
 
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import { api_base_url, base_url} from '../common/Constants';
 
class Machines extends React.Component{
 
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/> 
                 <Helmet>
                    <title>{metas[5].title}</title>  
                    <meta name="description" content={metas[5].meta_description} />
                    <meta name="keywords" content={metas[5].meta_title} />
                    <meta property="og:image" content={base_url+"assets/img/about-2.png"}  />
                    <link rel="canonical" href={base_url+'machines'} />
                </Helmet>
                <PageHeader title="List of Machines"/>
                <MachinesContent content={JSON.parse(localStorage.getItem("content"))} machines={JSON.parse(localStorage.getItem("machines"))} />  
                <Footer/>
            </div>
       
        )
    }

}
export default Machines;